var _ellipse, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayPndActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0001,
    cy: 13,
    rx: 13,
    ry: 13,
    fill: "#16A02C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_12593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0254 6.55493C14.9302 6.58825 13.8162 7.22381 12.1237 8.20929L9.37677 9.8089H8.88641C8.61743 9.8089 8.32702 9.8208 8.24133 9.83508C7.83429 9.89935 7.49628 10.185 7.3606 10.5825C7.31299 10.7182 7.31299 10.7801 7.31299 14.2483C7.31299 17.3166 7.31775 17.7903 7.34869 17.895C7.45581 18.2521 7.7486 18.5449 8.10565 18.652C8.21039 18.6829 8.83642 18.6877 13.1306 18.6877C18.4388 18.6877 18.108 18.6948 18.3746 18.5615C18.5221 18.4853 18.7316 18.2783 18.8149 18.1235C18.9339 17.9069 18.953 17.7736 18.953 17.1999C18.953 16.6358 18.9458 16.6001 18.8268 16.512C18.7602 16.4644 18.7292 16.462 17.5414 16.4477C16.4988 16.4358 16.3036 16.4287 16.187 16.3954C15.3801 16.155 14.7897 15.5551 14.5922 14.7672C14.5184 14.4792 14.5184 14.0007 14.5922 13.7294C14.8088 12.9296 15.4205 12.3226 16.2179 12.1155C16.4084 12.0655 16.4798 12.0607 17.5819 12.0536C18.853 12.0417 18.8459 12.0417 18.9173 11.9036C18.9696 11.8013 18.9696 10.8229 18.9149 10.6396C18.7935 10.2278 18.4674 9.92315 18.0722 9.84936L17.9389 9.82318L17.1296 8.40924C16.2727 6.9096 16.187 6.78344 15.9466 6.64538C15.6705 6.49066 15.3158 6.45495 15.0254 6.55493ZM15.6157 7.13336C15.6847 7.16668 15.7609 7.22381 15.7871 7.2619L15.8323 7.32617L13.7019 8.56872L11.5691 9.8089L11.0621 9.80414L10.555 9.79699L12.8021 8.48779C14.0399 7.76654 15.1015 7.15478 15.1634 7.12622C15.3158 7.05243 15.461 7.05481 15.6157 7.13336ZM16.9654 9.2995C17.1177 9.56848 17.2391 9.79223 17.2344 9.79937C17.2272 9.80414 16.7107 9.80652 16.0846 9.80414L14.9468 9.79699L15.7895 9.30426C16.2536 9.0329 16.644 8.81152 16.6583 8.80914C16.6726 8.80914 16.8107 9.03051 16.9654 9.2995Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1442,
    y: 11.0872,
    width: 5.81127,
    height: 6.5,
    fill: "#FFF536"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0178 20.6839C20.0179 20.6839 21.6392 19.0626 21.6392 17.0625C21.6392 15.0624 20.0179 13.4411 18.0178 13.4411C16.0178 13.4411 14.3964 15.0624 14.3964 17.0625C14.3964 19.0626 16.0178 20.6839 18.0178 20.6839Z",
    fill: "#FFF536",
    stroke: "#16A02C",
    strokeWidth: 0.742856
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0179 14.6785V17.2785H19.6429",
    stroke: "#16A02C",
    strokeWidth: 0.557142
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_12593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1875,
    height: 12.1875,
    fill: "white",
    transform: "translate(7.31311 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPndActive);
export default __webpack_public_path__ + "static/media/pay_pnd_Active.d65dc5c7927c2c9170d7614811b9a5e0.svg";
export { ForwardRef as ReactComponent };